import {LayoutType} from "./constants";
import {UseFullSizeImages} from "../../../config";
import {getCurrentLayout} from "../../appLayout";

let layouts = {};
Object.keys(LayoutType).forEach(layoutName => {
  layouts[layoutName] = {
    center_island_sink: 3100,
    center_island_faucet: 3200,
    oven: 4900,
    dishwasher: 5000,
    fridge: 5100,
    hood: 5200,
    microwave: 5300,
    range: 5400,
    decor: 11111,
    sink: 18000,
    faucet: 19000,
    center_island_countertop: 59000,
    center_island_cabinet: 60000,
    countertop: 61000,
    bottom_cabinet: 62000,
    top_cabinet: 63000,
    backsplash: 64000,
    center_wall: 65000,
    front_wall: 66000,
    left_wall: 67000,
    right_wall: 68000,
    kitchen_floor: 69000,
    background_bg: 70000,
  };
});

const getLayerDimensions = (layer, currentLayout, canvasDimensions) => {
  const fullImagesFactor = UseFullSizeImages ? 177.77 : 100;
  const sizeFactor = fullImagesFactor / 100;
  const {coords} = layer;

  if (!coords) {
    return null
  }

  const COORDS_MAX = 1;
  // const isWallMobile = window.innerWidth <= 1024 && layer.partId.includes("wall");

  const x1Percentage = (coords.min_x * 100) / COORDS_MAX;
  const x2Percentage = (coords.max_x * 100) / COORDS_MAX;
  const y1Percentage = (coords.min_y * 100) / COORDS_MAX;
  const y2Percentage = (coords.max_y * 100) / COORDS_MAX;
  let x1 = sizeFactor*((canvasDimensions.width * x1Percentage) / 100);
  let x2 = sizeFactor*((canvasDimensions.width * x2Percentage) / 100);
  let y1 = sizeFactor*((canvasDimensions.height * y1Percentage) / 100);
  let y2 = sizeFactor*((canvasDimensions.height * y2Percentage) / 100);
  // if (!isWallMobile) { // make layer bigger (to add some semi-transparent pixels)
  //   x1 = x1 - 100;
  //   x2 = x2 + 100;
  //   y1 = y1 - 100;
  //   y2 = y2 + 100;
  // }
  return {
    polygonArray: [[x1, y1], [x2, y1], [x2, y2], [x1, y2]],
    width: (x2 - x1),
    height:(y2 - y1)
  };
};

const getMenuByHoveredLayer = (currentLayout, layer) => {
  const layout = getCurrentLayout();
  switch (layer.partId) {
    case "sink":
    case "faucet":
    case "countertop":
    case "edge_profile":
      return {
        contextMenuPartId: "countertop_group_custom"
      };
    case "center_island_sink":
    case "center_island_faucet":
    case "center_island_edge":
    case "center_island_countertop":
    case "center_island_stovetop":
      return {
        contextMenuPartId: "center_island_custom"
      };
    default: {
      const featureGroup = layout.getFeatureGroupByPartId(layer.partId);
      if (!featureGroup) {
        return ""
      }
      return {
        parent: featureGroup.getParent().partName,
        child: featureGroup.partName
      }
    }
  }
};

export default {
  layouts,
  getMenuByHoveredLayer,
  getLayerDimensions
}


